module.exports = __webpack_public_path__ + "IMG_0608.png?955b9bed7e3ec66adab8f87f00cac7a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/IMG_0608.png
// module id = 23
// module chunks = 0